import { render, staticRenderFns } from "./CategoryStart.vue?vue&type=template&id=519751f0&scoped=true&"
import script from "./CategoryStart.vue?vue&type=script&lang=js&"
export * from "./CategoryStart.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStart.vue?vue&type=style&index=0&id=519751f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519751f0",
  null
  
)

export default component.exports